import {Component, Inject} from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef} from '@angular/material/dialog';
import { GraphComponent, INode } from '@yfiles/yfiles';
import { FUNCTION, FunctionService } from '../../model-services/function.service';
import { Linqset } from '../../common/linqset-model';
import { Organisation } from '../../common/organisation';

// the node properties panel in a dialog, for pages without the side panel (and double-clicking a node)
@Component({
    selector: 'node-dialog',
    templateUrl: 'node-dialog.html',
    styles: ['.readonly-note { margin: 0 0 8px; font-size: 13px; color: var(--slate); }'],
    standalone: false
})
export class NodeDialogComponent {
    // opened here rather than by a model service, as this dialog runs functions through FunctionService
    static open(dialog:MatDialog, organisation:Organisation, graphComponent:GraphComponent, linqset:Linqset, organisationLinqset:Linqset, node:INode): void {
        const data = {node, graph:graphComponent.graph, linqset, organisation, organisationLinqset}

        dialog.open(NodeDialogComponent, {data, width:'700px', hasBackdrop:true});
    }

    constructor(
        public dialogRef: MatDialogRef<NodeDialogComponent>,
        @Inject(MAT_DIALOG_DATA) public data:any,
        private functionService:FunctionService
    ) {
    }

    isReadonly() {
        return this.data.linqset?.readonly
    }

    // actions the panel asks for (such as merging nodes) reload the model, so close first
    async handleFunction(event:{function:FUNCTION, value?:any}) {
        this.dialogRef.close(this.data.node)
        await this.functionService.executeFunction(event.function, event.value)
    }

    onCancelClick(): void {
        this.dialogRef.close();
    }
}
